import * as React from "react";
import type { SVGProps } from "react";
const SvgSkipForward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m5 4 .625-.78A1 1 0 0 0 4 4zm10 8 .625.78a1 1 0 0 0 0-1.56zM5 20H4a1 1 0 0 0 1.625.78zM20 5a1 1 0 1 0-2 0zm-2 14a1 1 0 1 0 2 0zM4.375 4.78l10 8 1.25-1.56-10-8zm10 6.44-10 8 1.25 1.56 10-8zM6 20V4H4v16zM18 5v14h2V5z"
    />
  </svg>
);
export default SvgSkipForward;
